export const MODE_SINGLE_USER = 'user';
export const MODE_EVERYONE =
  'https://media.giphy.com/media/7cTTE2Z1OmrFm/giphy.gif';
